import React, { useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { handleRequestError } from 'api/handleRequestError'
import * as profileApi from 'features/profile/api/profile.api'
import CustomToast from 'ui/CustomToast'
import SignatureConfirmationModal from 'components/SignatureConfirmationModal/SignatureConfirmationModal'
import SignatureComponent from 'components/SignatureComponent/SignatureComponent'
import { useAuth } from 'features/auth/store/authStore'

const SetupSignature = () => {
  const { user, refreshUserData, setSignature } = useAuth()
  const navigate = useNavigate()

  const [signatureData, setSignatureData] = useState(null)
  const [signaturePreview, setSignaturePreview] = useState(null)
  const [isSubmitting, setIsSubmitting] = useState(false)
  const [showModal, setShowModal] = useState(false)
  const [error, setError] = useState('')

  const handleSaveClick = () => {
    if (!signatureData) {
      setError('Please provide a signature to continue.')
      return
    }
    setShowModal(true)
  }

  const handleSignatureSave = (blob) => {
    setSignatureData(blob)
    setError('')

    const previewUrl = URL.createObjectURL(blob)
    setSignaturePreview(previewUrl)
  }

  const submitToApi = async () => {
    try {
      setIsSubmitting(true)
      const formData = new FormData()
      formData.append('signature', signatureData, `signature_${Date.now()}.png`)

      const response = await profileApi.updateSignature(formData, {
        headers: { 'Content-Type': 'multipart/form-data' },
      })

      if (response.data.success) {
        CustomToast({
          message: 'Signature saved successfully!',
          type: 'success',
        })
        setSignature(response.data?.signature)
      }
    } catch (err) {
      handleRequestError(err)
    } finally {
      setIsSubmitting(false)
      setShowModal(false)
    }
  }

  return (
    <div className='flex flex-col items-center justify-center min-h-screen p-6 bg-gray-50'>
      <div className='w-full max-w-md p-8 bg-white rounded-lg shadow-md'>
        <h2 className='mb-4 text-2xl font-bold text-center'>
          Setup Your Signature
        </h2>
        <p className='mb-6 text-sm text-center text-gray-600'>
          To complete your profile and sign documents, please provide your
          digital signature.
        </p>

        <SignatureComponent
          initialValue={signaturePreview}
          onSave={(blob) => {
            handleSignatureSave(blob)
          }}
          penColor='black'
        />

        {error && <p className='mt-2 text-xs text-danger'>{error}</p>}

        <button
          onClick={handleSaveClick}
          className='w-full mt-6 btn btn-primary'
          disabled={isSubmitting}
        >
          {isSubmitting ? 'Saving...' : 'Save Signature'}
        </button>
      </div>

      <SignatureConfirmationModal
        isOpen={showModal}
        isLoading={isSubmitting}
        onClose={() => setShowModal(false)}
        onConfirm={submitToApi}
      />
    </div>
  )
}

export default SetupSignature
